<template>
    <div>
        <div class="c-slider-images" >
            
            <v-slide-y-transition>
              <div v-show="slider_1" class="c-slider-image">
                <img src="/images/slider-image-1.png" />
              </div>
            </v-slide-y-transition>
            
            <v-slide-y-transition>
              <div v-show="slider_2" class="c-slider-image">
                <img src="/images/slider-image-1.png" />
              </div>
            </v-slide-y-transition>
            
            <v-slide-y-transition>
              <div v-show="slider_3" class="c-slider-image">
                <img src="/images/slider-image-1.png" />
              </div>
            </v-slide-y-transition>
            
        </div>
        <div class="c-slider-pages">
            <div v-if="slider_1 == true" class="c-slider-page c-slider-page-active" @click="slider(1)"></div>
            <div v-else class="c-slider-page" @click="slider(1)"></div>

            <div v-if="slider_2 == true" class="c-slider-page c-slider-page-active" @click="slider(2)"></div>
            <div v-else class="c-slider-page" @click="slider(2)"></div>

            <div v-if="slider_3 == true" class="c-slider-page c-slider-page-active" @click="slider(3)"></div>
            <div v-else class="c-slider-page" @click="slider(3)"></div>

        </div>
    </div>
</template>

<script>
    export default {
        props: [],
        data: () => ({
          slider_1: true,
          slider_2: false,
          slider_3: false,
        }),
        methods: {
            slider(page){
                if(page == 1){
                    this.slider_1 = true;
                    this.slider_2 = false;
                    this.slider_3 = false;
                }
                
                if(page == 2){
                    this.slider_1 = false;
                    this.slider_2 = true;
                    this.slider_3 = false;
                }
                
                if(page == 3){
                    this.slider_1 = false;
                    this.slider_2 = false;
                    this.slider_3 = true;
                }
            }
        }
    }
</script>
